import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from '../../../models/report.model';

@Pipe({
  name: 'reportStatus'
})
export class ReportStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let result = '';
    switch(value) {
      case ReportStatus.NEW:
      case ReportStatus.PENDING:
      case ReportStatus.PROCESSING:
      case ReportStatus.FAILED:
      case ReportStatus.SKIPPED:
        result = 'W realizacji';
        break;
      case ReportStatus.PROCESSED:
        result = 'Gotowy';
        break;
      case null:
        result = 'Oczekuje';
        break;
    }
    return result;
  }

}
